import { ChangePasswordModel } from 'shared/definition';
import { Component, OnInit, ViewChild, Injector } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { SpinningService } from 'shared/services';
import { onFormSubmit } from 'shared/utils';
import { CurrentUserApiService } from 'shared/services/current-user-api.service';
import { RouterUtils } from 'shared/utils/router-utils';
import { __isMobile } from 'shared/consts/__is-mobile';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { NzTreeNodeOptions } from 'ng-zorro-antd/tree';
import { NzTreeSelectComponent } from 'ng-zorro-antd/tree-select';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
})
export class ChangePasswordComponent implements OnInit {
  size = {
    label: '126px',
    control: 'auto',
  };
  editMode: boolean;
  form: FormGroup;
  orgNodes: NzTreeNodeOptions[] = [];
  userId: string;
  countDown = 3;
  protected fb: FormBuilder;
  protected get modalRef(): NzModalRef | NzDrawerRef {
    return __isMobile
      ? this.injector.get(NzDrawerRef)
      : this.injector.get(NzModalRef);
  }
  protected userApi: CurrentUserApiService;
  protected spinningService: SpinningService;
  protected routerUtils: RouterUtils;

  @ViewChild('parentTree') parentTree: NzTreeSelectComponent;
  constructor(protected injector: Injector) {
    this.fb = injector.get(FormBuilder);
    // this.modalRef = __isMobile ? injector.get(NzDrawerRef) : injector.get(NzModalRef);
    this.userApi = injector.get(CurrentUserApiService);
    this.spinningService = injector.get(SpinningService);
    this.routerUtils = injector.get(RouterUtils);
    this.form = this.fb.group({
      currentPassword: this.fb.control(undefined, [Validators.required]),
      newPassword: this.fb.control(undefined, [Validators.required]),
      confirmPassword: this.fb.control(undefined, [
        Validators.required,
        this.comparePassword.bind(this),
      ]),
    });
  }

  ngOnInit(): void {
    this.userId = localStorage.getItem('userId');
    this.form.controls['newPassword'].valueChanges.subscribe(() => {
      this.form.controls['confirmPassword'].updateValueAndValidity();
    });
  }

  async save() {
    // for (const key in this.form.controls) {
    //   this.form.controls[key].updateValueAndValidity();
    //   this.form.controls[key].markAsDirty();
    // }

    onFormSubmit(this.form);
    if (this.form.invalid) return;
    const model = <ChangePasswordModel>{
      ...this.form.value,
    };
    model.userId = this.userId;
    await this.spinningService
      .startWith(this.userApi.changePassword(model))
      .toPromise();
    this.routerUtils.afterPasswordChanged();
  }
  cancel() {
    this.modalRef.close();
  }

  comparePassword(control: AbstractControl): ValidationErrors {
    if (!control.value) return null;
    const confirmPassword = control.value;
    const newPassword = this.form.controls['newPassword'].value;
    if (confirmPassword !== newPassword) {
      return {
        compare: true,
      };
    }
    return null;
  }
}
